var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip-component',{scopedSlots:_vm._u([{key:"tooltip",fn:function(){return [_vm._v(" "+_vm._s(_vm.tooltip)+" ")]},proxy:true}])},[_c('span',[_vm._v(_vm._s(_vm.formattedCurrency))])])}
var staticRenderFns = []

export { render, staticRenderFns }